import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/shared/components/ui/dialog";

interface ParseWillDialogProps {
  isOpen: boolean;
  onClose?: () => void;
  onComplete?: () => void;
}

export default function ParseWillDialog({ isOpen, onClose, onComplete }: ParseWillDialogProps) {
  const handleClose = () => {
    onClose?.();
    onComplete?.();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Parse Will Document</DialogTitle>
        </DialogHeader>
        <div className="p-4">
          <p>Will parsing functionality coming soon.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
